// extracted by mini-css-extract-plugin
export default {"container":"LittleBox_container__14Kz6","icon":"LittleBox_icon__Vri1x","text":"LittleBox_text__KxNXX","infoBox":"LittleBox_infoBox__z+SqR","title":"LittleBox_title__+et6+"};